var map = {
	"./_module_demo_/translation/en.json": 56536,
	"./_module_demo_/translation/it.json": 22826,
	"./assistant/translation/en.json": 97700,
	"./assistant/translation/it.json": 53930,
	"./consumer/translation/en.json": 54766,
	"./consumer/translation/it.json": 16920,
	"./dashboard/translation/en.json": 18784,
	"./dashboard/translation/it.json": 22738,
	"./kitchen-order-ticket/translation/en.json": 56910,
	"./kitchen-order-ticket/translation/it.json": 39406,
	"./menu-management/translation/en.json": 78504,
	"./menu-management/translation/it.json": 39771,
	"./profile/translation/en.json": 19470,
	"./profile/translation/it.json": 66678,
	"./settings/translation/en.json": 38097,
	"./settings/translation/it.json": 78449,
	"./shop/translation/en.json": 4346,
	"./shop/translation/it.json": 82516,
	"./sport-hub-club/translation/en.json": 17960,
	"./sport-hub-club/translation/it.json": 60016,
	"./sport-hub-league/translation/en.json": 44063,
	"./sport-hub-league/translation/it.json": 78580,
	"./sport-hub-pay/translation/en.json": 55964,
	"./sport-hub-pay/translation/it.json": 31498,
	"./sport-hub-pro/translation/en.json": 56458,
	"./sport-hub-pro/translation/it.json": 12816,
	"./sport-hub-web/translation/en.json": 24692,
	"./sport-hub-web/translation/it.json": 99418,
	"./sport-hub/translation/en.json": 410,
	"./sport-hub/translation/it.json": 82119,
	"./waitress-order-ticket/translation/en.json": 53923,
	"./waitress-order-ticket/translation/it.json": 5249
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 28502;